<lms-breadcrumb></lms-breadcrumb>
<div class="flex-between">
  <div class="lms-toolbar__selector">
    <span *ngIf="myClientsFilterEnabled">
      <gl-select
        [value]="myClientsOptionSelected"
        [options]="myClientsFilterOptions"
        (onChange)="onSelectorChange($event.detail.value)"
      >
      </gl-select>
    </span>
  </div>
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'clients.create'" tools-actions>
      <gl-button
        color-primary
        [routerLink]="['/clients/new']"
        title="{{ 'clients.add' | translate }}"
        [text]="'clients.add' | translate"
      >
      </gl-button>
    </div>
  </lms-toolbar>
</div>

<lms-clients-list [listId]="listId" [options]="listOptions"></lms-clients-list>
